import { Fragment, useRef, useState } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline'
import { PlusIcon, XMarkIcon, PencilSquareIcon, TrashIcon } from '@heroicons/react/24/solid';

export default function Delete({ product }) {
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)

  return (
    <>
    <button type="button" onClick={() => setOpen(true)} className="flex w-full items-center py-2 px-4 hover:bg-gray-100 text-red-500 ">
        <TrashIcon className="w-4 h-4 mr-2"/>
        Supprimer
    </button>

    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative z-40" initialFocus={cancelButtonRef} onClose={setOpen}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all md:ml-64 sm:my-8 w-full sm:max-w-md">
                <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                    <div className="mt-3 sm:mt-0 text-left">
                      {/* <Dialog.Title as="div" className="flex justify-between ">
                        <p className='text-xl font-semibold leading-6 text-gray-900'></p>
                        <button
                            type="button"
                            className="inline-flex justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-100 sm:mt-0 w-auto"
                            onClick={() => setOpen(false)}
                            ref={cancelButtonRef}>
                            <XMarkIcon className='w-5 h-5 text-gray-900'/>
                        </button>
                      </Dialog.Title> */}
                      <div className="mt-0">
                            <div className=' justify-center text-center py-2'>
                                <div className='flex justify-center items-center pb-2 text-gray-700'>
                                    <TrashIcon className=" w-12 h-12"/>
                                </div>
                                <p className='text-gray-900'>Etes-vous sûr(e) de vouloir supprimer cette catégorie</p>
                            </div>
                            <div className='flex justify-center space-x-2 mt-2'>
                              <button type="button"  onClick={() => setOpen(false)} ref={cancelButtonRef} className="text-black inline-flex items-center bg-gray-100 border border-black hover:bg-gray-300 focus:ring-4 focus:outline-none focus:ring-gray-500 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                                  {/* <XMarkIcon className="mr-1 -ml-1 w-6 h-6"/> */}
                                  Non, annuler
                              </button>
                              <form>
                                <button type="submit" className="text-white inline-flex items-center bg-red-600 hover:bg-red-800  focus:ring-4 focus:outline-none focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ">
                                  {/* <TrashIcon className="mr-1 -ml-1 w-6 h-6"/> */}
                                  Oui, je suis sûr(e)
                                </button>
                              </form>
                            </div>
                    </div>
                    </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
    </>
  )
}
